import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconDrizzle({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.03824 23.176C7.92306 23.5741 8.08128 23.8339 8.33611 23.9496C8.59063 24.0654 8.84515 23.9951 8.96065 23.597C9.07583 23.1989 8.9015 22 8.9015 22C8.9015 22 8.15374 22.7779 8.03793 23.176H8.03824Z"
        fill="white"
      />
      <path
        d="M14.0382 23.176C13.9231 23.5741 14.0813 23.8339 14.3361 23.9496C14.5906 24.0654 14.8452 23.9951 14.9606 23.597C15.0758 23.1989 14.9015 22 14.9015 22C14.9015 22 14.1537 22.7779 14.0379 23.176H14.0382Z"
        fill="white"
      />
      <path
        d="M20.0382 23.176C19.9231 23.5741 20.0813 23.8339 20.3361 23.9496C20.5906 24.0654 20.8452 23.9951 20.9606 23.597C21.0758 23.1989 20.9015 22 20.9015 22C20.9015 22 20.1537 22.7779 20.0379 23.176H20.0382Z"
        fill="white"
      />
      <path
        d="M9.03849 26.1754C8.92272 26.5742 9.08151 26.8333 9.33596 26.949C9.59071 27.0663 9.84515 26.9944 9.96061 26.5964C10.0758 26.1991 9.9018 25 9.9018 25C9.9018 25 9.15364 25.7778 9.03849 26.1754Z"
        fill="white"
      />
      <path
        d="M15.0385 26.1754C14.9227 26.5742 15.0815 26.8333 15.336 26.949C15.5907 27.0663 15.8452 26.9944 15.9606 26.5964C16.0758 26.1991 15.9018 25 15.9018 25C15.9018 25 15.1536 25.7778 15.0385 26.1754Z"
        fill="white"
      />
      <path
        d="M21.0385 26.1754C20.9227 26.5742 21.0815 26.8333 21.336 26.949C21.5907 27.0663 21.8452 26.9944 21.9606 26.5964C22.0758 26.1991 21.9018 25 21.9018 25C21.9018 25 21.1536 25.7778 21.0385 26.1754Z"
        fill="white"
      />
      <path
        d="M10.0382 23.176C9.92306 23.5741 10.0813 23.8339 10.3361 23.9496C10.5906 24.0654 10.8452 23.9951 10.9606 23.597C11.0758 23.1989 10.9015 22 10.9015 22C10.9015 22 10.1537 22.7779 10.0379 23.176H10.0382Z"
        fill="white"
      />
      <path
        d="M16.0382 23.176C15.9231 23.5741 16.0813 23.8339 16.3361 23.9496C16.5906 24.0654 16.8452 23.9951 16.9606 23.597C17.0758 23.1989 16.9015 22 16.9015 22C16.9015 22 16.1537 22.7779 16.0379 23.176H16.0382Z"
        fill="white"
      />
      <path
        d="M22.0382 23.176C21.9231 23.5741 22.0813 23.8339 22.3361 23.9496C22.5906 24.0654 22.8452 23.9951 22.9606 23.597C23.0758 23.1989 22.9015 22 22.9015 22C22.9015 22 22.1537 22.7779 22.0379 23.176H22.0382Z"
        fill="white"
      />
      <path
        d="M11.0385 26.1754C10.9227 26.5742 11.0815 26.8333 11.336 26.949C11.5907 27.0663 11.8452 26.9944 11.9606 26.5964C12.0758 26.1991 11.9018 25 11.9018 25C11.9018 25 11.1536 25.7778 11.0385 26.1754Z"
        fill="white"
      />
      <path
        d="M17.0385 26.1754C16.9227 26.5742 17.0815 26.8333 17.336 26.949C17.5907 27.0663 17.8452 26.9944 17.9606 26.5964C18.0758 26.1991 17.9018 25 17.9018 25C17.9018 25 17.1536 25.7778 17.0385 26.1754Z"
        fill="white"
      />
      <path
        d="M23.0385 26.1754C22.9227 26.5742 23.0815 26.8333 23.336 26.949C23.5907 27.0663 23.8452 26.9944 23.9606 26.5964C24.0758 26.1991 23.9018 25 23.9018 25C23.9018 25 23.1536 25.7778 23.0385 26.1754Z"
        fill="white"
      />
      <path
        d="M13.0385 26.1754C12.9227 26.5742 13.0815 26.8333 13.336 26.949C13.5907 27.0663 13.8452 26.9944 13.9606 26.5964C14.0758 26.1991 13.9018 25 13.9018 25C13.9018 25 13.1536 25.7778 13.0385 26.1754Z"
        fill="white"
      />
      <path
        d="M19.0385 26.1754C18.9227 26.5742 19.0815 26.8333 19.336 26.949C19.5907 27.0663 19.8452 26.9944 19.9606 26.5964C20.0758 26.1991 19.9018 25 19.9018 25C19.9018 25 19.1536 25.7778 19.0385 26.1754Z"
        fill="white"
      />
      <path
        d="M25.0385 26.1754C24.9227 26.5742 25.0815 26.8333 25.336 26.949C25.5907 27.0663 25.8452 26.9944 25.9606 26.5964C26.0758 26.1991 25.9018 25 25.9018 25C25.9018 25 25.1536 25.7778 25.0385 26.1754Z"
        fill="white"
      />
      <path
        d="M12.0382 23.176C11.9231 23.5741 12.0813 23.8339 12.3357 23.9496C12.5904 24.0654 12.8449 23.9951 12.9607 23.597C13.0758 23.1989 12.9015 22 12.9015 22C12.9015 22 12.154 22.7779 12.0382 23.176Z"
        fill="white"
      />
      <path
        d="M18.0382 23.176C17.9231 23.5741 18.0813 23.8339 18.3357 23.9496C18.5904 24.0654 18.8449 23.9951 18.9607 23.597C19.0758 23.1989 18.9015 22 18.9015 22C18.9015 22 18.154 22.7779 18.0382 23.176Z"
        fill="white"
      />
      <path
        d="M24.0382 23.176C23.9231 23.5741 24.0813 23.8339 24.3357 23.9496C24.5904 24.0654 24.8449 23.9951 24.9607 23.597C25.0758 23.1989 24.9015 22 24.9015 22C24.9015 22 24.154 22.7779 24.0382 23.176Z"
        fill="white"
      />
      <path
        d="M22.4753 9.24168C22.4233 9.24168 22.3734 9.24891 22.3221 9.24957C21.7453 6.81439 19.5633 5 16.9506 5C14.207 5 11.9375 7.00246 11.5061 9.62375C11.1642 9.52905 10.8051 9.47382 10.4309 9.47382C8.53103 9.47382 6.9455 10.8016 6.53909 12.5778C5.05351 13.1591 4 14.602 4 16.2954C4 18.5017 5.78874 20.2891 7.99573 20.2891H22.4753C25.526 20.2891 28 17.8178 28 14.7664C28 11.715 25.526 9.24102 22.4753 9.24102V9.24168Z"
        fill="white"
      />
    </svg>
  );
}
